import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicAmplification({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M7.555 7.898l.404.404a.427.427 0 010 .606L4.33 12.537l2.971-.072a.426.426 0 01.438.428v.56c0 .237-.192.43-.428.428l-4.907.001a.427.427 0 01-.428-.428V8.546c0-.238.191-.43.428-.428h.56c.24 0 .433.198.428.438l-.072 2.97 3.63-3.628a.427.427 0 01.606 0zm6.041-5.78c.238 0 .43.192.428.428v4.908c0 .238-.191.43-.428.428h-.56a.429.429 0 01-.428-.438l.072-2.97-3.63 3.628a.427.427 0 01-.606 0l-.404-.404a.427.427 0 010-.606l3.629-3.629-2.971.072a.426.426 0 01-.438-.428v-.56c0-.237.192-.43.428-.428l4.907-.001z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicAmplification.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicAmplification.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicAmplification svgRef={ref} {...props} />
));
export default ForwardRef;
